import React from "react";

const L = ["0001101", "0011001", "0010011", "0111101", "0100011", "0110001", "0101111", "0111011", "0110111", "0001011"];
const G = ["0100111", "0110011", "0011011", "0100001", "0011101", "0111001", "0000101", "0010001", "0001001", "0010111"];
const R = ["1110010", "1100110", "1101100", "1000010", "1011100", "1001110", "1010000", "1000100", "1001000", "1110100"];
const PARITY = ["LLLLLL", "LLGLGG", "LLGGLG", "LLGGGL", "LGLLGG", "LGGLLG", "LGGGLL", "LGLGLG", "LGLGGL", "LGGLGL"];

function modules(code) {
  const d = code.split("").map(Number);
  const parity = PARITY[d[0]];
  let bits = "101";
  for (let i = 0; i < 6; i++) bits += (parity[i] === "L" ? L : G)[d[i + 1]];
  bits += "01010";
  for (let i = 7; i < 13; i++) bits += R[d[i]];
  return bits + "101";
}

/** Scanbare EAN13-barcode als pure SVG (geen extra pakket). */
export default function Ean13({ code, scale = 2, height = 56, className = "" }) {
  if (!/^\d{13}$/.test(code || "")) return null;
  const bits = modules(code);
  const quiet = 10 * scale;
  const width = quiet * 2 + bits.length * scale;
  const total = height + 16;
  const isGuard = (i) => i < 3 || (i >= 45 && i < 50) || i >= 92;
  const bars = [];
  for (let i = 0; i < bits.length; i++) {
    if (bits[i] !== "1") continue;
    bars.push(<rect key={i} x={quiet + i * scale} y={0} width={scale} height={isGuard(i) ? height + 8 : height} fill="#000" />);
  }
  const fs = 9 * scale;
  return (
    <svg width={width} height={total} viewBox={`0 0 ${width} ${total}`} className={className} data-testid="ean13-barcode" role="img" aria-label={`Barcode ${code}`}>
      <rect x="0" y="0" width={width} height={total} fill="#fff" />
      {bars}
      <g fill="#000" fontFamily="monospace" fontSize={fs}>
        <text x={quiet - 2} y={total - 1} textAnchor="end">{code[0]}</text>
        <text x={quiet + 3 * scale + 21 * scale} y={total - 1} textAnchor="middle">{code.slice(1, 7)}</text>
        <text x={quiet + 50 * scale + 21 * scale} y={total - 1} textAnchor="middle">{code.slice(7)}</text>
      </g>
    </svg>
  );
}
